var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "resume-body custom-resume-body" },
    [
      _vm._m(0),
      _c("div", { staticClass: "border" }, [
        _c("div", { staticClass: "border-bottom" }, [
          _vm._v(
            " 1.錄取後可上班時間:" +
              _vm._s(
                _vm.idlResume.WorkedInfo.AvailableOnBoardDateOption
                  ? _vm.idlResume.WorkedInfo.AvailableOnBoardDateOption
                  : "無"
              ) +
              " "
          ),
        ]),
        _c(
          "div",
          { staticClass: "border-bottom" },
          [
            _vm._v(" 2.是否收到日月光主動邀約: "),
            typeof _vm.idlResume.WorkedInfo.IsInvited === "boolean"
              ? [
                  _vm._v(
                    " " +
                      _vm._s(_vm.idlResume.WorkedInfo.IsInvited ? "是" : "否") +
                      " "
                  ),
                ]
              : [_vm._v("無")],
          ],
          2
        ),
        _c(
          "div",
          { staticClass: "border-bottom" },
          [
            _vm._v(" 3.*曾至本公司應徵工作? "),
            typeof _vm.idlResume.WorkedInfo.HasAppliedCompany === "boolean"
              ? [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.idlResume.WorkedInfo.HasAppliedCompany ? "是" : "否"
                      ) +
                      " "
                  ),
                ]
              : [_vm._v("無")],
          ],
          2
        ),
        _c(
          "div",
          { staticClass: "border-bottom" },
          [
            _vm._v(" 4.是否曾任職於本公司: "),
            typeof _vm.idlResume.WorkedInfo.HasWorkedInCompany === "boolean"
              ? [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.idlResume.WorkedInfo.HasWorkedInCompany
                          ? "是"
                          : "否"
                      ) +
                      " "
                  ),
                ]
              : [_vm._v("無")],
          ],
          2
        ),
        _c(
          "div",
          [
            _vm._v(" 5.招募管道來源: "),
            _vm.idlResume.WorkedInfo.RecruitmentSource
              ? [
                  _vm._v(
                    " " +
                      _vm._s(_vm.idlResume.WorkedInfo.RecruitmentSource) +
                      _vm._s(
                        _vm.idlResume.WorkedInfo
                          .RecruitmentSourceDescActivityShool
                      ) +
                      _vm._s(
                        _vm.idlResume.WorkedInfo
                          .RecruitmentSourceDescActivityOrg
                      ) +
                      _vm._s(
                        _vm.idlResume.WorkedInfo
                          .RecruitmentSourceDescActivityOther
                      ) +
                      _vm._s(
                        _vm.idlResume.WorkedInfo
                          .RecruitmentSourceDescCenterOther
                      ) +
                      _vm._s(
                        _vm.idlResume.WorkedInfo.RecruitmentSourceDescFlyerOther
                      ) +
                      _vm._s(
                        _vm.idlResume.WorkedInfo
                          .RecruitmentSourceDescJobBankOther
                      ) +
                      _vm._s(
                        _vm.idlResume.WorkedInfo.RecruitmentSourceDescHunter
                      ) +
                      _vm._s(
                        _vm.idlResume.WorkedInfo
                          .RecruitmentSourceDescOtherSource
                      ) +
                      " "
                  ),
                ]
              : [_vm._v("無")],
          ],
          2
        ),
      ]),
      _vm._v(" 一、個人資料 "),
      _c("table", [
        _c("tr", [
          _c("th", { attrs: { id: "name" } }, [_vm._v("中文姓名")]),
          _c("td", [_vm._v(_vm._s(_vm.name))]),
          _c("td", [_vm._v("英文姓名")]),
          _c("td", [
            _vm._v(
              " " +
                _vm._s(
                  _vm.idlResume.BaseInfo.EnglishName
                    ? _vm.idlResume.BaseInfo.EnglishName
                    : "無"
                ) +
                " "
            ),
          ]),
          _c("td", [_vm._v("性別")]),
          _c("td", [_vm._v(_vm._s(_vm.idlResume.BaseInfo.Sex))]),
          _c(
            "td",
            {
              staticClass: "center-text",
              attrs: { colspan: "2", rowspan: "3" },
            },
            [
              _c("img", {
                staticStyle: {
                  width: "125px",
                  height: "125px",
                  "object-fit": "cover",
                },
                attrs: {
                  src: _vm.headPhotoBase64
                    ? _vm.headPhotoBase64
                    : require(`@/assets/img/head2.png`),
                  alt: "",
                },
              }),
            ]
          ),
        ]),
        _c("tr", [
          _c("td", [_vm._v("國籍")]),
          _c("td", [_vm._v(_vm._s(_vm.idlResume.BaseInfo.Nationality))]),
          _c("td", [_vm._v("外籍在台原因")]),
          _c("td", [
            _vm._v(
              " " +
                _vm._s(
                  _vm.idlResume.BaseInfo.ForeignerReason
                    ? _vm.idlResume.BaseInfo.ForeignerReason
                    : "無"
                ) +
                " " +
                _vm._s(
                  _vm.idlResume.BaseInfo.ForeignerReasonDesc
                    ? "-" + _vm.idlResume.BaseInfo.ForeignerReasonDesc
                    : null
                ) +
                " "
            ),
          ]),
          _c("td", [_vm._v("身分證字號/護照號碼")]),
          _c("td", [_vm._v(_vm._s(_vm.idlResume.BaseInfo.IdNo))]),
        ]),
        _c("tr", [
          _c("td", [_vm._v("生日")]),
          _c("td", [
            _vm._v(
              _vm._s(_vm.$common.dateFormatter(_vm.idlResume.BaseInfo.BirthDay))
            ),
          ]),
          _c("td", [_vm._v("個人手機")]),
          _c("td", [_vm._v(_vm._s(_vm.idlResume.BaseInfo.MobilePhone))]),
          _c("td", [_vm._v("家用電話(區域碼-號碼)")]),
          _c("td", [
            _vm._v(
              _vm._s(
                _vm.idlResume.BaseInfo.Phone
                  ? _vm.idlResume.BaseInfo.Phone
                  : "無"
              )
            ),
          ]),
        ]),
        _c("tr", [
          _c("td", [_vm._v("是否有身心障礙手冊")]),
          _c("td", [
            _vm._v(
              " " +
                _vm._s(_vm.idlResume.BaseInfo.HasDisabilityCard ? "是" : "否")
            ),
            _c("br"),
            _vm._v(
              " " +
                _vm._s(
                  _vm.idlResume.BaseInfo.HasDisabilityCardDesc
                    ? "：" + _vm.idlResume.BaseInfo.HasDisabilityCardDesc
                    : null
                ) +
                " "
            ),
          ]),
          _c("td", [_vm._v("說明")]),
          _c("td", [
            _vm._v(
              " " + _vm._s(_vm.idlResume.BaseInfo.HasDisabilityCardDesc) + " "
            ),
          ]),
          _c("td", [_vm._v("身高")]),
          _c("td", [
            _vm._v(
              _vm._s(
                _vm.idlResume.BaseInfo.Height
                  ? _vm.idlResume.BaseInfo.Height + "cm"
                  : "無"
              )
            ),
          ]),
          _c("td", { staticStyle: { width: "50px" } }, [_vm._v("體重")]),
          _c("td", { staticStyle: { width: "65px" } }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.idlResume.BaseInfo.Weight
                    ? _vm.idlResume.BaseInfo.Weight + "kg"
                    : "無"
                ) +
                " "
            ),
          ]),
        ]),
        _c("tr", [
          _c("td", [_vm._v("視力")]),
          _c("td", [
            _vm._v(
              " " +
                _vm._s(_vm.idlResume.BaseInfo.VisualAcuity) +
                _vm._s(
                  _vm.idlResume.BaseInfo.VisualAcuityDesc
                    ? "，說明：" + _vm.idlResume.BaseInfo.VisualAcuityDesc
                    : null
                ) +
                " "
            ),
          ]),
          _c("td", { attrs: { colspan: "2" } }, [
            _c("span", [
              _vm._v("左眼度數：" + _vm._s(_vm.idlResume.BaseInfo.SPHLeft)),
            ]),
            _c("span", [
              _vm._v("、右眼度數：" + _vm._s(_vm.idlResume.BaseInfo.SPHRight)),
            ]),
          ]),
          _c("td", [_vm._v("是否有散光")]),
          _c("td", [
            _vm._v(_vm._s(_vm.idlResume.BaseInfo.HasAstigmatic ? "是" : "否")),
          ]),
          _c("td", { attrs: { colspan: "2" } }, [
            _c("span", [
              _vm._v("左眼度數：" + _vm._s(_vm.idlResume.BaseInfo.CYLLeft)),
            ]),
            _vm._v("、"),
            _c("span", [
              _vm._v("右眼度數：" + _vm._s(_vm.idlResume.BaseInfo.CYLRight)),
            ]),
          ]),
        ]),
        _c("tr", [
          _c("td", [_vm._v("住處")]),
          _c("td", [_vm._v(_vm._s(_vm.idlResume.BaseInfo.ResidenceType))]),
          _c("td", [_vm._v("出勤方式")]),
          _c("td", [_vm._v(_vm._s(_vm.idlResume.BaseInfo.CommutingType))]),
          _c("td", [_vm._v("通勤時間")]),
          _c("td", { attrs: { colspan: "3" } }, [
            _vm._v(_vm._s(_vm.idlResume.BaseInfo.CommutingMinutes) + "分鐘"),
          ]),
        ]),
        _c("tr", [
          _c("td", [_vm._v("通訊地址")]),
          _c("td", { attrs: { colspan: "7" } }, [
            _vm._v(
              " " +
                _vm._s(_vm.idlResume.BaseInfo.ContactCounty) +
                _vm._s(_vm.idlResume.BaseInfo.ContactDistrict) +
                " " +
                _vm._s(_vm.idlResume.BaseInfo.ContactVillage) +
                _vm._s(_vm.idlResume.BaseInfo.ContactAddress) +
                " "
            ),
          ]),
        ]),
        _c("tr", [
          _c("td", [_vm._v("戶籍地址")]),
          _c("td", { attrs: { colspan: "7" } }, [
            _vm._v(
              " " +
                _vm._s(_vm.idlResume.BaseInfo.County) +
                _vm._s(_vm.idlResume.BaseInfo.District) +
                " " +
                _vm._s(_vm.idlResume.BaseInfo.Village) +
                _vm._s(_vm.idlResume.BaseInfo.Address) +
                " "
            ),
          ]),
        ]),
        _c("tr", [
          _c("td", [_vm._v("Email")]),
          _c("td", { attrs: { colspan: "7" } }, [
            _vm._v(" " + _vm._s(_vm.idlResume.BaseInfo.Email) + " "),
          ]),
        ]),
        _c("tr", [
          _c("td", [_vm._v("緊急聯絡人姓名")]),
          _c("td", { attrs: { colspan: "2" } }, [
            _vm._v(_vm._s(_vm.idlResume.BaseInfo.EmergencyContact)),
          ]),
          _c("td", [_vm._v("緊急聯絡人關係")]),
          _c("td", { attrs: { colspan: "2" } }, [
            _vm._v(_vm._s(_vm.idlResume.BaseInfo.EmergencyContactRelationship)),
          ]),
          _c("td", [_vm._v("緊急聯絡人電話(手機)")]),
          _c("td", { attrs: { colspan: "3" } }, [
            _vm._v(_vm._s(_vm.idlResume.BaseInfo.EmergencyContactPhone)),
          ]),
        ]),
        _c("tr", [
          _c("td", [_vm._v("緊急聯絡人地址")]),
          _c("td", { attrs: { colspan: "6" } }, [
            _vm._v(
              " " +
                _vm._s(_vm.idlResume.BaseInfo.EmergencyContactCounty) +
                _vm._s(_vm.idlResume.BaseInfo.EmergencyContactDistrict) +
                " " +
                _vm._s(_vm.idlResume.BaseInfo.EmergencyContactVillage) +
                _vm._s(_vm.idlResume.BaseInfo.EmergencyContactAddress) +
                " "
            ),
          ]),
        ]),
      ]),
      _vm._v(" 二、學歷 "),
      _c(
        "table",
        [
          _vm._m(1),
          _vm._l(_vm.idlResume.Educations, function (education, index) {
            return _c("tr", { key: education.Id }, [
              _c("td", [_vm._v(_vm._s(index + 1))]),
              _c("td", [
                _vm._v(
                  " " +
                    _vm._s(
                      education.SchoolGuid ===
                        "11111111-1111-1111-1111-111111111111"
                        ? education.SchoolDescription
                        : education.School
                    ) +
                    " "
                ),
              ]),
              _c("td", [_vm._v(_vm._s(education.EducationCategory))]),
              _c("td", [
                _vm._v(
                  _vm._s(education.MajorName ? education.MajorName : "無")
                ),
              ]),
              _c("td", [
                _vm._v(_vm._s(education.IsDaySchool ? "日校" : "夜校")),
              ]),
              _c("td", [
                _vm._v(
                  _vm._s(_vm.$common.monthFormatter(education.EducationFrom))
                ),
              ]),
              _c("td", [
                _vm._v(
                  " " +
                    _vm._s(
                      education.EducationTo
                        ? _vm.$common.monthFormatter(education.EducationTo)
                        : "無"
                    ) +
                    " "
                ),
              ]),
              _c("td", [_vm._v(_vm._s(education.IsGraduate ? "是" : "否"))]),
            ])
          }),
          _c("tr", [
            _c("td", { attrs: { colspan: "2" } }, [
              _vm._v("短期內是否有繼續升學或進修的計畫"),
            ]),
            _c("td", [
              _vm._v(
                _vm._s(
                  _vm.idlResume.BaseInfo.InSchoolOrHasStudyPlan ? "是" : "否"
                )
              ),
            ]),
            _c("td", [_vm._v("請詳述計畫內容")]),
            _c("td", { attrs: { colspan: "4" } }, [
              _vm._v(_vm._s(_vm.idlResume.BaseInfo.InSchoolOrHasStudyPlanDesc)),
            ]),
          ]),
        ],
        2
      ),
      _vm._v(" 三、工作經歷 "),
      _c(
        "table",
        { staticClass: "experience-table" },
        [
          _vm._m(2),
          _vm._l(
            _vm.idlResume.WorkExperiences.WorkExperiences,
            function (experience, index) {
              return _c("tr", { key: experience.Id }, [
                _c("td", [_vm._v(_vm._s(index + 1))]),
                _c("td", [
                  _vm._v(
                    _vm._s(experience.Seniority ? experience.Seniority : "無") +
                      "年"
                  ),
                ]),
                _c("td", [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$common.monthFormatter(experience.ExperienceFrom)
                      ) +
                      "~" +
                      _vm._s(
                        experience.ExperienceTo
                          ? _vm.$common.monthFormatter(experience.ExperienceTo)
                          : ""
                      ) +
                      " "
                  ),
                ]),
                _c("td", [
                  _vm._v(
                    " 底薪:" +
                      _vm._s(
                        experience.BasicSalary
                          ? _vm.$common.currencyThousands(
                              String(experience.BasicSalary)
                            )
                          : "無"
                      )
                  ),
                  _c("br"),
                  _vm._v(
                    " 固定津貼: " +
                      _vm._s(
                        experience.FixedAllowance
                          ? _vm.$common.currencyThousands(
                              String(experience.FixedAllowance)
                            )
                          : "無"
                      )
                  ),
                  _c("br"),
                  _vm._v(
                    " 變動獎金:" +
                      _vm._s(
                        experience.VaryingBonus
                          ? _vm.$common.currencyThousands(
                              String(experience.VaryingBonus)
                            )
                          : "無"
                      )
                  ),
                  _c("br"),
                  _vm._v(
                    " 年薪: " +
                      _vm._s(
                        experience.YearlySalary
                          ? _vm.$common.currencyThousands(
                              String(experience.YearlySalary)
                            )
                          : "無"
                      ) +
                      " "
                  ),
                ]),
                _c("td", [
                  _vm._v(" 產業:" + _vm._s(experience.IndustryCategory)),
                  _c("br"),
                  _vm._v(" 公司名稱:" + _vm._s(experience.Company)),
                  _c("br"),
                  _vm._v(
                    " 工作地點:" +
                      _vm._s(
                        experience.WorkCounty ? experience.WorkCounty : "無"
                      ) +
                      "/" +
                      _vm._s(
                        experience.WorkDistrict ? experience.WorkDistrict : "無"
                      ) +
                      " "
                  ),
                ]),
                _c("td", [_vm._v(" " + _vm._s(experience.Position) + " ")]),
                _c("td", { staticClass: "work-content-wrap" }, [
                  experience.WorkContent
                    ? _c("span", {
                        domProps: { innerHTML: _vm._s(experience.WorkContent) },
                      })
                    : _c("span", [_vm._v("無")]),
                ]),
                _c("td", [
                  _vm._v(" " + _vm._s(experience.OnTheJob ? "是" : "否")),
                  _c("br"),
                  _vm._v(" 離職原因: " + _vm._s(experience.LeaveReason) + " "),
                ]),
              ])
            }
          ),
          _c("tr", [
            _c("td", [_vm._v("合計年資")]),
            _c("td", [_vm._v(_vm._s(_vm.totalSeniority) + "年")]),
            _c("td", [_vm._v("期望全薪")]),
            _c("td", { attrs: { colspan: "2" } }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.idlResume.BaseInfo.ExpectedMonthlySalary
                      ? _vm.$common.currencyThousands(
                          String(_vm.idlResume.BaseInfo.ExpectedMonthlySalary)
                        )
                      : "無"
                  ) +
                  " "
              ),
            ]),
            _c("td", [_vm._v("期望年薪")]),
            _c("td", { attrs: { colspan: "2" } }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.idlResume.BaseInfo.ExpectedYearlySalary
                      ? _vm.$common.currencyThousands(
                          String(_vm.idlResume.BaseInfo.ExpectedYearlySalary)
                        )
                      : "無"
                  ) +
                  " "
              ),
            ]),
          ]),
        ],
        2
      ),
      _vm._v(" 四、保密義務 "),
      _c(
        "table",
        [
          _c("tr", [
            _vm._m(3),
            _c("td", { attrs: { colspan: "4" } }, [
              _vm.idlResume.NDA.HasNDA
                ? _c("span", [_vm._v("是")])
                : _vm.idlResume.NDA.HasNDA === null
                ? _c("span", [_vm._v("應聘者尚未填寫")])
                : _c("span", [_vm._v("對其他公司不負有保密義務")]),
            ]),
          ]),
          _vm._l(_vm.idlResume.NDA.Details, function (nda, index) {
            return _c("tr", { key: index }, [
              _c("td", [_vm._v("所負義務對象")]),
              _c("td", [_vm._v(_vm._s(nda.Company))]),
              _c("td", [_vm._v("保密義務內容")]),
              _c("td", [_vm._v(_vm._s(nda.Content))]),
              _c("td", [_vm._v("是否永久")]),
              _c("td", [_vm._v(_vm._s(nda.IsPermanent ? "是" : "否"))]),
              _c("td", [_vm._v("保密義務期間（起-迄）")]),
              _c("td", [
                _vm._v(
                  " " +
                    _vm._s(_vm.$common.dateFormatter(nda.StartDate)) +
                    "~" +
                    _vm._s(_vm.$common.dateFormatter(nda.EndDate)) +
                    " "
                ),
              ]),
            ])
          }),
        ],
        2
      ),
      _vm._v(" 五、競業禁止 "),
      _c(
        "table",
        [
          _c("tr", [
            _vm._m(4),
            _c("td", { attrs: { colspan: "4" } }, [
              _vm.idlResume.NCC.HasNCC
                ? _c("span", [_vm._v("是")])
                : _vm.idlResume.NCC.HasNCC === null
                ? _c("span", [_vm._v("應聘者尚未填寫")])
                : _c("span", [_vm._v("未與其他公司簽訂競業禁止條款")]),
            ]),
          ]),
          _vm.idlResume.NCC.HasNCC
            ? [
                _vm._l(_vm.idlResume.NCC.Details, function (ncc, index) {
                  return [
                    _c("tr", { key: index }, [
                      _c("td", [_vm._v("所負義務對象")]),
                      _c("td", [_vm._v(_vm._s(ncc.Company))]),
                      _c("td", [_vm._v("競業禁止合約檔案")]),
                      _c(
                        "td",
                        _vm._l(ncc.ContractFiles, function (file) {
                          return _c("div", { key: file.FileGuid }, [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "blue",
                                  cursor: "pointer",
                                  "text-decoration": "underline",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.$common.downloadFile({
                                      fileGuid: file.FileGuid,
                                      fileType: file.FileContentType,
                                    })
                                  },
                                },
                              },
                              [_vm._v(" " + _vm._s(file.FileName) + " ")]
                            ),
                            _c("br"),
                          ])
                        }),
                        0
                      ),
                      _c("td", [_vm._v("競業禁止區域")]),
                      _c("td", [_vm._v(_vm._s(ncc.District))]),
                      _c("td", [_vm._v("競業禁止範圍")]),
                      _c("td", [_vm._v(_vm._s(ncc.Scope))]),
                    ]),
                    _c("tr", { key: "e" + index }, [
                      _c("td", [_vm._v("競業禁止期間（起-迄）")]),
                      _c("td", [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$common.dateFormatter(ncc.StartDate)) +
                            "~" +
                            _vm._s(_vm.$common.dateFormatter(ncc.EndDate)) +
                            " "
                        ),
                      ]),
                      _c("td", [_vm._v("備註事項")]),
                      _c("td", { attrs: { colspan: "5" } }, [
                        _vm._v(" " + _vm._s(ncc.Remark) + " "),
                      ]),
                    ]),
                  ]
                }),
              ]
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" 六、智財 "),
      _c(
        "table",
        [
          _c("tr", [
            _c("th", { attrs: { id: "ip", colspan: "2" } }, [
              _vm._v(
                "是否有取得或正在申請中之智財?（專利、商標、著作權或其他）"
              ),
            ]),
            _c("td", [
              _vm.idlResume.IP.HasIP
                ? _c("span", [_vm._v("是")])
                : _vm.idlResume.IP.HasIP === null
                ? _c("span", [_vm._v("應聘者尚未填寫")])
                : _c("span", [_vm._v("尚未擁有智財")]),
            ]),
          ]),
          _vm._m(5),
          _vm.idlResume.IP.HasIP
            ? _vm._l(_vm.idlResume.IP.Details, function (ip, index) {
                return _c("tr", { key: index }, [
                  _c("td", [_vm._v(_vm._s(ip.IPCode))]),
                  _c("td", [_vm._v(_vm._s(ip.IPCategory))]),
                  _c("td", [
                    _c("div", { staticStyle: { "word-break": "break-all" } }, [
                      _vm._v(" " + _vm._s(ip.Description) + " "),
                    ]),
                  ]),
                ])
              })
            : _vm.idlResume.IP.HasIP === null
            ? [_vm._m(6)]
            : [_vm._m(7)],
        ],
        2
      ),
      _vm._v(" 七、專業技能及認證 "),
      _c("table", [
        _c("tr", [
          _c("th", { attrs: { id: "skill" } }, [_vm._v("電腦技能")]),
          _c("td", [
            _vm._v(
              " " +
                _vm._s(
                  _vm.idlResume.Skill.ComputerSkill
                    ? _vm.idlResume.Skill.ComputerSkill
                    : "無"
                ) +
                " "
            ),
          ]),
        ]),
        _c("tr", [
          _c("td", [_vm._v("培訓紀錄")]),
          _c("td", [
            _vm._v(
              " " +
                _vm._s(
                  _vm.idlResume.Skill.TrainingRecord
                    ? _vm.idlResume.Skill.TrainingRecord
                    : "無"
                ) +
                " "
            ),
          ]),
        ]),
        _c("tr", [
          _c("td", [_vm._v("證照檢定")]),
          _c("td", [
            _vm._v(
              _vm._s(
                _vm.idlResume.Skill.Certificate
                  ? _vm.idlResume.Skill.Certificate
                  : "無"
              )
            ),
          ]),
        ]),
        _c("tr", [
          _c("td", [_vm._v("論文(題目)")]),
          _c("td", [
            _vm._v(
              _vm._s(
                _vm.idlResume.Skill.PaperTheme
                  ? _vm.idlResume.Skill.PaperTheme
                  : "無"
              )
            ),
          ]),
        ]),
        _c("tr", [
          _c("td", [_vm._v("論文(摘要)")]),
          _c("td", [
            _vm._v(
              _vm._s(
                _vm.idlResume.Skill.PaperSummary
                  ? _vm.idlResume.Skill.PaperSummary
                  : "無"
              )
            ),
          ]),
        ]),
        _c("tr", [
          _c("td", [_vm._v("工作專長")]),
          _c("td", [
            _vm._v(
              _vm._s(
                _vm.idlResume.Skill.Specialty
                  ? _vm.idlResume.Skill.Specialty
                  : "無"
              )
            ),
          ]),
        ]),
      ]),
      _vm._v(" 八、活動經驗 "),
      _c("table", [
        _c("tr", [
          _c("th", { attrs: { id: "activity" } }, [_vm._v("社團/興趣")]),
          _c("td", [
            _vm._v(
              " " +
                _vm._s(
                  _vm.idlResume.ActivityExperience.Interest
                    ? _vm.idlResume.ActivityExperience.Interest
                    : "無"
                ) +
                " "
            ),
          ]),
        ]),
        _c("tr", [
          _c("td", [_vm._v("優良事蹟")]),
          _c("td", [
            _vm._v(
              " " +
                _vm._s(
                  _vm.idlResume.ActivityExperience.OutstandingPerformance
                    ? _vm.idlResume.ActivityExperience.OutstandingPerformance
                    : "無"
                ) +
                " "
            ),
          ]),
        ]),
        _c("tr", [
          _c("td", [_vm._v("挫折忍耐度")]),
          _c("td", [
            _vm._v(
              " " +
                _vm._s(
                  _vm.idlResume.ActivityExperience.FrustrationTolerance
                    ? _vm.idlResume.ActivityExperience.FrustrationTolerance
                    : "無"
                ) +
                " 具體實例:" +
                _vm._s(
                  _vm.idlResume.ActivityExperience.ExtracurricularActivities
                    ? _vm.idlResume.ActivityExperience.ExtracurricularActivities
                    : "無"
                ) +
                " "
            ),
          ]),
        ]),
      ]),
      _vm._v(" 九、語言能力 "),
      _c(
        "table",
        [
          _vm._m(8),
          _vm.idlResume.Languages && _vm.idlResume.Languages.length > 0
            ? _vm._l(_vm.idlResume.Languages, function (language, index) {
                return _c("tr", { key: index }, [
                  _c("td", [
                    _vm._v(
                      " " +
                        _vm._s(
                          language.LanguageGuid ===
                            "11111111-1111-1111-1111-111111111111"
                            ? language.LanguageDescription
                            : language.Language
                        ) +
                        " "
                    ),
                  ]),
                  _c("td", [
                    _vm._v(
                      _vm._s(
                        language.LanguageTest ? language.LanguageTest : "無"
                      )
                    ),
                  ]),
                  _c("td", [
                    _vm._v(
                      " " +
                        _vm._s(language.Listen ? language.Listen : "無") +
                        " "
                    ),
                  ]),
                  _c("td", [
                    _vm._v(_vm._s(language.Speak ? language.Speak : "無")),
                  ]),
                  _c("td", [
                    _vm._v(_vm._s(language.Read ? language.Read : "無")),
                  ]),
                  _c("td", [
                    _vm._v(_vm._s(language.Write ? language.Write : "無")),
                  ]),
                ])
              })
            : [_vm._m(9)],
        ],
        2
      ),
      _vm._v(" 十、工作配合 "),
      _c("table", [
        _c("tr", [
          _c("th", { attrs: { id: "work" } }, [_vm._v("未來輪班配合")]),
          _c(
            "td",
            [
              typeof _vm.idlResume.WorkCooperation.CanShiftWork === "boolean"
                ? [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.idlResume.WorkCooperation.CanShiftWork
                            ? "是"
                            : "否"
                        ) +
                        " "
                    ),
                  ]
                : [_vm._v("無")],
              _vm.idlResume.WorkCooperation.CanShiftWorkDesc
                ? [
                    _c("br"),
                    _vm._v(
                      " 說明：" +
                        _vm._s(_vm.idlResume.WorkCooperation.CanShiftWorkDesc) +
                        " "
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _c("td", [_vm._v("未來出差/派駐配合")]),
          _c(
            "td",
            [
              _vm.idlResume.WorkCooperation.CanOfficeTripOrStation === null
                ? [_vm._v(" 無 ")]
                : [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.idlResume.WorkCooperation.CanOfficeTripOrStation
                        ) +
                        " "
                    ),
                  ],
              _vm.idlResume.WorkCooperation.CanOfficeTripOrStationDesc
                ? [
                    _c("br"),
                    _vm._v(
                      " 說明：" +
                        _vm._s(
                          _vm.idlResume.WorkCooperation
                            .CanOfficeTripOrStationDesc
                        ) +
                        " "
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ]),
        _c("tr", [
          _c("td", { attrs: { colspan: "2" } }, [
            _vm._v(
              " 是否有任何個人、家庭因素會影響工作配合度、工作時間、需常請假等等事項 "
            ),
          ]),
          _c(
            "td",
            { attrs: { colspan: "2" } },
            [
              typeof _vm.idlResume.WorkCooperation.HasLackOfWorkCooperation ===
              "boolean"
                ? [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.idlResume.WorkCooperation.HasLackOfWorkCooperation
                            ? "是"
                            : "否"
                        ) +
                        " "
                    ),
                  ]
                : [_vm._v("無")],
              _vm.idlResume.WorkCooperation.HasLackOfWorkCooperationDesc
                ? [
                    _c("br"),
                    _vm._v(
                      " 說明：" +
                        _vm._s(
                          _vm.idlResume.WorkCooperation
                            .HasLackOfWorkCooperationDesc
                        ) +
                        " "
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ]),
      ]),
      _vm._v(" 十一、請列出最近參加面試的工作職缺情況: "),
      _c(
        "table",
        [
          _vm._m(10),
          _vm.idlResume.InterviewInfos &&
          _vm.idlResume.InterviewInfos.length > 0
            ? _vm._l(_vm.idlResume.InterviewInfos, function (info, index) {
                return _c("tr", { key: index }, [
                  _c("td", [_vm._v(_vm._s(info.Company))]),
                  _c("td", [_vm._v(_vm._s(info.IndustryCategory))]),
                  _c("td", [
                    _vm._v(_vm._s(info.County) + "/" + _vm._s(info.District)),
                  ]),
                  _c("td", [
                    _vm._v(
                      _vm._s(_vm.$common.dateFormatter(info.InterviewDate))
                    ),
                  ]),
                  _c("td", [_vm._v(_vm._s(info.Position))]),
                  _c("td", [_vm._v(_vm._s(info.InterviewResult))]),
                  _c("td", [_vm._v(_vm._s(info.BasicSalary))]),
                ])
              })
            : [_vm._m(11)],
        ],
        2
      ),
      _vm._v(
        " 十二、請選擇您應徵此工作職缺的需求：《請依重要性，排序第1~第10順位》 "
      ),
      _vm.idlResume.WorkConsiderations.length === 0
        ? [_vm._v(" 無"), _c("br"), _c("br")]
        : _c("table", [
            _c(
              "tr",
              [
                _c("th", { attrs: { id: "seq" } }, [_vm._v("順序")]),
                _vm._l(
                  _vm.idlResume.WorkConsiderations,
                  function (element, index) {
                    return _c("td", { key: index }, [
                      _vm._v(" " + _vm._s(++index) + " "),
                    ])
                  }
                ),
              ],
              2
            ),
            _c(
              "tr",
              [
                _c("td", [_vm._v("項目")]),
                _vm._l(
                  _vm.idlResume.WorkConsiderations,
                  function (element, index) {
                    return _c("td", { key: index }, [
                      _vm._v(" " + _vm._s(element.Item) + " "),
                    ])
                  }
                ),
              ],
              2
            ),
            _c(
              "tr",
              [
                _c("td", [_vm._v("原因")]),
                _vm._l(
                  _vm.idlResume.WorkConsiderations,
                  function (element, index) {
                    return _c("td", { key: index }, [
                      _vm._v(" " + _vm._s(element.Reason) + " "),
                    ])
                  }
                ),
              ],
              2
            ),
          ]),
      _vm._v(" 十三、自傳 "),
      _c("table", [
        _c("tr", [
          _c("th", { attrs: { id: "autobiography" } }, [
            _vm.idlResume.Autobiography.Autobiography
              ? _c("span", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.idlResume.Autobiography.Autobiography
                    ),
                  },
                })
              : _c("span", [_vm._v("無")]),
          ]),
        ]),
      ]),
      _vm._m(12),
      _c("br"),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "border" }, [
      _vm._v(" 【個人資料蒐集、處理及利用告知事項】"),
      _c("br"),
      _vm._v(
        " 為保護台端權益，請詳閱以下告知事項，台端於下表提供個人資料並簽名即表示已理解並同意以下規定： 本公司基於招募聘用、 人事管理、業務執行及相關營運需要之目的(下合稱「特定目的」)有必要於所在地 以紙本、電子文件、電磁紀錄或其他合於當時 科學技術之適當方式，在符合個人資料保護相關法令之範圍 內，蒐集、於國內與國際間處理與利用台端於下表即未來所提供之個 人資料(下稱「個人資料」)，並得於 特定目的消失後保存至少15年。台端個人資料利用對象包括本公司及本公司國內外關係企業 (下稱「本公 司關係企業」)、本公司及本公司關係企業之職工福利委員會、財團法人日月之光慈善事業基金會、財團法 人日月光 文教基金會、以上公司、關係企業及組織之職員、代理人、專業顧問、及其所委託之第三人以及 依法令得提供其台端個人資料之 人。台端得依個人資料保護法第三條行使之相關權利包括(1)查詢或請求閱 覽(2)請求製給複製本(3)請求補充或更正(4)請求停止蒐 集、處理或利用(5)請求刪除。台端得自由選擇是 否提供相關個人資料，台端若拒絕提供相關個人資料或未確實完整填寫，本公司 可能無法進行相關審核及 處理作業而影響台端支應徵或任職機會。 "
      ),
      _c("div", { staticStyle: { "text-align": "right" } }, [
        _vm._v(" 簽名：___________________ 民國____年____月____日 "),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("th", { attrs: { id: "no" } }, [_vm._v("No.")]),
      _c("td", [_vm._v("學校")]),
      _c("td", [_vm._v("學歷")]),
      _c("td", [_vm._v("科系名稱")]),
      _c("td", [_vm._v("日校/夜校")]),
      _c("td", [_vm._v("入學日期")]),
      _c("td", [_vm._v("離校日期")]),
      _c("td", [_vm._v("是否畢業")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("th", { attrs: { id: "no" } }, [_vm._v("No.")]),
      _c("td", { staticClass: "width-5" }, [_vm._v("年資")]),
      _c("td", { staticClass: "width-10" }, [_vm._v("工作期間")]),
      _c("td", { staticClass: "width-10" }, [_vm._v("薪資")]),
      _c("td", { staticClass: "width-15" }, [_vm._v("公司/產業")]),
      _c("td", { staticClass: "width-10" }, [_vm._v("職稱")]),
      _c("td", [_vm._v("主要工作內容")]),
      _c("td", { staticClass: "width-10" }, [_vm._v("在職與否/(欲)離職原因")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("th", { attrs: { id: "nda", colspan: "4" } }, [
      _vm._v(" 本人是否對其他公司負有保密義務?"),
      _c("br"),
      _vm._v(
        " 註：「保密義務」是指您對於前雇主的機密資訊負有保密責任，離職之後不得繼續使用、揭露或持有。 "
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("th", { attrs: { id: "ncc", colspan: "4" } }, [
      _vm._v(" 本人是否與其他公司簽訂競業禁止條款 ?"),
      _c("br"),
      _vm._v(
        " 註：「保密義務」是指您對於前雇主的機密資訊負有保密責任，離職之後不得繼續使用、揭露或持有。 "
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("td", [_vm._v("IP code")]),
      _c("td", [_vm._v("類型")]),
      _c("td", { staticClass: "width-60" }, [_vm._v("說明")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("td", { attrs: { colspan: "3" } }, [_vm._v("應聘者尚未填寫")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("td", { attrs: { colspan: "3" } }, [_vm._v("尚未擁有智財")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("th", { attrs: { id: "language" } }, [_vm._v("種類")]),
      _c("td", [_vm._v("語言檢定")]),
      _c("td", [_vm._v("聽")]),
      _c("td", [_vm._v("說")]),
      _c("td", [_vm._v("讀")]),
      _c("td", [_vm._v("寫")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [_c("td", { attrs: { colspan: "6" } }, [_vm._v("無")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("th", { attrs: { id: "company" } }, [_vm._v("公司名稱")]),
      _c("td", [_vm._v("產業")]),
      _c("td", [_vm._v("地點")]),
      _c("td", [_vm._v("面試日期")]),
      _c("td", [_vm._v("應徵職務")]),
      _c("td", [_vm._v("面試結果")]),
      _c("td", [_vm._v("薪資")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [_c("td", { attrs: { colspan: "7" } }, [_vm._v("無")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "border" }, [
      _vm._v(" 【聲明事項】"),
      _c("br"),
      _vm._v(
        " 1. 本人已詳閱並瞭解 貴公司依個人資料保護法及相關法令之規定所告知本履歷表內個人資料之蒐集目的、利用之期間、 地區、對象及方式、依個人資料保護法第三條規定得行使之權利及權利行使方式以及不提供本履歷表內個人資料時將對 本人權益之影響，本人於茲表示同意 貴公司依據告知內容蒐集、處理及利用本人之個人資料。 "
      ),
      _c("br"),
      _vm._v(
        " 2. 本人聲明並擔保於本履歷表內所提供第三人之個人資料，業獲該等人員同意提供其個人資料並允許相關之蒐集、處理 及利用，如有爭議發生，悉由本人負相關法律責任，並賠償 貴公司因此所受之損害。 "
      ),
      _c("br"),
      _vm._v(
        " 3. 本人確認於本履歷表內填載之各項資料與陳述均屬實，並同意 貴公司就本履歷表內所提供資料內容之正確性進行查證，如有虛偽不實之情事，本人願無條件接受 貴公司解僱處分，如涉及違法，全憑 貴公司依法處理。 "
      ),
      _c("br"),
      _vm._v(
        " 4. 本人聲明並擔保本人至 貴公司應徵未違反本人與現任雇主、前雇主或其他第三人之兼職禁止、競業禁止、利益衝突禁 止、保密協議、智慧財產權協議或其他類似之約定，前開狀態若於接獲錄取通知至 貴公司報到前有所變動，本人將主動告知並提供 貴公司所需資訊。本人並承諾確實遵守智慧財產權相關法律及本人應履行之保密或智慧財產權相關約定，應 徵期間所有之行為，絕不洩漏或侵害現任雇主、前雇主或其他第三人之營業秘密、機密資訊或其他智慧財產權。如有違 反本條，悉由本人負相關法律責任，並賠償 貴公司因此所受之損害。 "
      ),
      _c("br"),
      _vm._v(
        " 5. 本人同意如因本人未提供正確個人資料導致權益受影響或遭遇緊急事件時無法獲得迅速妥善之處理，相關後果與責任 悉由本人自行承擔。 "
      ),
      _c("br"),
      _vm._v(
        " 6. 本人同意如此次未獲 貴公司錄用或個人放棄報到， 貴公司得保留本人資料並列入儲備人員，日後若有適當職缺時得再行通知本人。 "
      ),
      _c("br"),
      _vm._v(
        " 7. 本人已詳閱「妊娠與分娩後女性及未滿十八歲勞工禁止從事危險性或有害性工作」之相關規定。"
      ),
      _c("br"),
      _c("div", { staticStyle: { "text-align": "right" } }, [
        _vm._v(" 簽名：___________________ 民國____年____月____日 "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }